import { PartialBrief } from '../../../../Types/Brief'
import ATTRIBUTES_BY_EVENT_TYPE from './attributesByEventType'

const getForcedLayout = ({ collectionName }: PartialBrief): string | undefined =>
  ATTRIBUTES_BY_EVENT_TYPE[collectionName ?? '']?.forceLayout

export default getForcedLayout
